import { Outlet, useLocation, useSearchParams } from 'react-router-dom'
import React, { useCallback, useEffect, useState } from 'react'
import { Box, useTheme } from '@mui/material'

import TryAgainMessageBlock from '../../components/common/TryAgainMessageBlock'
import AuditPageHeader from '../../components/audit/AuditPageHeader'
import { getCountString, Icons } from '../../utils/utilities'
import api from '../../service/api'

const AuditMeetings = () => {

    const [searchParams] = useSearchParams( { searchText: "", month: "", selectedDepartment: "all", selectedInstitute: "all", view: "tabular", sortByName: "1", sortBySubmissionsCount: "1", sortByAssignmentCount: "1" } )
    const selectedInstitute = searchParams.get( 'selectedInstitute' ) || "all"
    const selectedDepartment = searchParams.get( 'selectedDepartment' ) || "all"

    const [error, setError] = useState( false )
    const [counts, setCounts] = useState( {} )
    const [loading, setLoading] = useState( true )


    const { layout } = useTheme()
    const { pathname } = useLocation()


    const getData = useCallback( async () => {
        try {
            setLoading( true )
            const department = selectedDepartment !== "all" ? selectedDepartment : ""
            const institute = selectedInstitute !== "all" ? selectedInstitute : ""

            const pathname = window.location.pathname

            const { data: { data: counts } } = await api.audit.getMeetingsCounts( { last30dayscount: true, institute, department, types: pathname.includes( 'online-classes' ) ? ["class"] : pathname.includes( 'hybrid-classes' ) ? ["hybrid-class"] : ["webinar", "discussion"] } )

            setCounts( counts )
            setError( null )
        } catch ( err ) {
            setError( { code: err?.response?.status, message: err?.response?.data?.message || "Something went wrong while fetching the assignment audit data." } )
        } finally {
            setLoading( false )
        }
    }, [selectedInstitute, selectedDepartment] )


    useEffect( () => {
        getData()
    }, [getData] )



    return (
        <Box padding={layout.pagePadding} display="flex" flexDirection="column" gap={layout.sectionsGap} overflow="auto" flexGrow={1}>

            {/* Header */}
            {!error && <AuditPageHeader
                loading={loading}
                title={pathname.includes( 'online-classes' ) ? "Online classes audit" : pathname.includes( 'hybrid-classes' ) ? "Hybrid classes audit" : "Meetings audit"}
                subtitle={pathname.includes( 'online-classes' ) ? "View all online classes stats here." : pathname.includes( 'hybrid-classes' ) ? "View all hybrid classes audit" : "View all meeting stats here."}
                countCards={[
                    {
                        icon: Icons.default.MeetingRooms,
                        label: pathname.includes( 'classes' ) ? "Classes" : "Meetings",
                        value: getCountString( counts.totalMeetingsCount ),
                        secondary: getCountString( counts.last30daysCount ),
                        secondaryLabel: "In last 30 days"
                    },
                    {
                        icon: Icons.default.Group,
                        label: "Participants",
                        value: getCountString( counts.totalParticipantsCount ),
                        secondary: getCountString( counts.last30dayParticipantsCount ),
                        secondaryLabel: "In last 30 days"
                    },
                    {
                        icon: Icons.default.FrontHand,
                        label: "Average Attendance",
                        value: getCountString( Math.ceil( counts.totalParticipantsCount / counts.totalMeetingsCount ) ),
                        secondary: getCountString( Math.ceil( counts.last30dayParticipantsCount / counts.last30daysCount ) ),
                        secondaryLabel: "In last 30 days"
                    },
                ]}
            />}

            {error && <Box sx={{ flexShrink: 0, padding: "20px" }}>
                <TryAgainMessageBlock getData={getData} err={error.message} code={error.code} loading={loading} />
            </Box>}
            <Outlet />
        </Box >
    )
}

export default AuditMeetings
